import React, { useState } from 'react';
import './AccountModals.css';

const ChangePasswordModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });
  const [error, setError] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    
    if (formData.newPassword !== formData.confirmNewPassword) {
      setError('New passwords do not match');
      return;
    }

    try {
      await onSubmit(formData);
      onClose();
      setFormData({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
    } catch (error) {
      console.log('Error object  :::', error);
      setError(error || 'Failed to change password');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Change Password</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="password-section">
            <label>Old Password</label>
            <input
              type="password"
              name="currentPassword"
              placeholder="Enter your current password"
              value={formData.currentPassword}
              onChange={(e) => setFormData({...formData, currentPassword: e.target.value})}
              required
            />
          </div>

          <div className="password-section">
            <label>New Password</label>
            <input
              type="password"
              name="newPassword"
              placeholder="Enter your new password"
              value={formData.newPassword}
              onChange={(e) => setFormData({...formData, newPassword: e.target.value})}
              required
              className="mb-3"  // Add this class for margin-bottom
            />
            <input
              type="password"
              name="confirmNewPassword"
              placeholder="Confirm your new password"
              value={formData.confirmNewPassword}
              onChange={(e) => setFormData({...formData, confirmNewPassword: e.target.value})}
              required
            />
          </div>
          
          <div className="modal-buttons">
            <button type="submit">Change Password</button>
            <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal; 